<template>
  <pf-tooltip>
    <template #content>
      <slot>{{ text }}</slot>
    </template>

    <help-icon />
  </pf-tooltip>
</template>

<script setup lang="ts">
import HelpIcon from "@vue-patternfly/icons/help-icon";
import type PfTooltip from '@vue-patternfly/core/components/Tooltip/Tooltip.vue';
import type { ComponentProps } from 'vue-component-type-helpers';

type PfTooltipProps = ComponentProps<typeof PfTooltip>;

interface Props extends /* @vue-ignore */ PfTooltipProps {
  text: string;
}

defineProps<Props>();

defineSlots<{
  default: (props?: Record<never, never>) => any;
}>();
</script>
